import { addEventListener } from '@datadog/browser-core';
export function onBFCacheRestore(configuration, callback) {
  const {
    stop
  } = addEventListener(configuration, window, "pageshow" /* DOM_EVENT.PAGE_SHOW */, event => {
    if (event.persisted) {
      callback(event);
    }
  }, {
    capture: true
  });
  return stop;
}
